@if (layout === 'empty') {
  <empty-layout></empty-layout>
}

@if (layout === 'modern') {
  <modern-layout></modern-layout>
}

@if (layout === 'classic') {
  <classic-layout></classic-layout>
}
